import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { ChevronUpDownRegular } from "@fluentui/react-icons";
import { useId } from "react";
import { twMerge } from "tailwind-merge";

type Value = string | number;

interface MultiSelectProps {
  value: Value[];
  data: {
    label: string;
    value: Value;
  }[];
  onChange: (value: Value[]) => void;
  placeholder?: string;
}
//TODO: generated by copilot, maybe change UI later
function MultiSelect({ value, data, onChange, placeholder }: MultiSelectProps) {
  const id = useId();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <div className="flex cursor-pointer justify-between gap-1 rounded-md border border-cool-gray-300 px-3 py-2">
          <span>{placeholder}</span>
          <ChevronUpDownRegular fontSize={16} className="text-cool-gray-400" />
        </div>
      </PopoverTrigger>
      <PopoverContent className="PopoverContent p-0">
        <div className="flex flex-col">
          {data.map((item) => {
            const selected = value.includes(item.value);
            return (
              <label
                htmlFor={`${id}-${item.value}`}
                key={item.value}
                className={twMerge(
                  "flex items-center gap-2 px-3 py-2",
                  selected && "bg-cool-gray-100",
                )}
              >
                <input
                  id={`${id}-${item.value}`}
                  type="checkbox"
                  className="h-4 w-4 rounded border border-input"
                  checked={selected}
                  onChange={(e) => {
                    if (e.target.checked) {
                      onChange([...value, item.value]);
                    } else {
                      onChange(value.filter((v) => v !== item.value));
                    }
                  }}
                />
                <span>{item.label}</span>
              </label>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default MultiSelect;
